import storage from "./storage";
import bus from "./event-bus";
import { isArray, isObject } from "./is";

function deepClone(obj) {
  let result;
  if (typeof obj === "object") {
    result = isArray(obj) ? [] : {};
    for (let i in obj) {
      result[i] = isObject(obj[i]) ? deepClone(obj[i]) : obj[i];
    }
  } else {
    result = obj;
  }
  return result;
}

export { storage, bus, deepClone };
